import React, { Suspense, lazy, Fragment } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Spinner, Pane } from "evergreen-ui";
import AuthenticatedRoute from "components/AuthenticatedRoute/AuthenticatedRoute";
import UnauthenticatedRoute from "components/UnauthenticatedRoute/UnauthenticatedRoute";
import { AdminRoute } from "components/AdminRoute";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
const AdminCases = lazy(() => import("containers/AdminCases"));
const AdminCasesDetail = lazy(() => import("containers/AdminCasesDetail"));
const AdminCaseEdit = lazy(() => import("containers/AdminCaseEdit"));
const AdminPendingGroups = lazy(() => import("containers/AdminPendingGroups"));
const AdminUsers = lazy(() => import("containers/AdminUsers"));
const AdminUsersEdit = lazy(() => import("containers/AdminUsersEdit"));
const AdminOrganisationsEdit = lazy(() =>
  import("containers/AdminOrganisationsEdit")
);
const AdminUsersDetail = lazy(() => import("containers/AdminUsersDetail"));
const AdminPendingOrganisations = lazy(() =>
  import("containers/AdminPendingOrganisations")
);
const AdminMergeOrganisations = lazy(() =>
  import("containers/AdminMergeOrganisations")
);
const AdminOrganisations = lazy(() => import("containers/AdminOrganisations"));
const Home = lazy(() => import("containers/Home"));
const About = lazy(() => import("containers/About"));
const BecomeInvolved = lazy(() => import("containers/BecomeInvolved"));
const Funding = lazy(() => import("containers/Funding"));
const Media = lazy(() => import("containers/Media"));
const MediaDetail = lazy(() => import("containers/MediaDetail"));
const Contact = lazy(() => import("containers/Contact"));
const NotFound = lazy(() => import("containers/NotFound"));
const Privacy = lazy(() => import("containers/Privacy"));
const Signup = lazy(() => import("containers/Signup"));
const Log = lazy(() => import("containers/Log"));
const Map = lazy(() => import("containers/Map"));
const Graph = lazy(() => import("containers/Graph"));
const PasswordReset = lazy(() => import("containers/PasswordReset"));
const CaseReports = lazy(() => import("containers/CaseReports"));
const CaseReportDetail = lazy(() => import("containers/CaseReportDetail"));
const CaseReportEdit = lazy(() => import("containers/CaseReportEdit"));
const Vaccination = lazy(() => import("containers/Vaccination"));
const Account = lazy(() => import("containers/Account"));
const AccountVerification = lazy(() =>
  import("containers/AccountVerification")
);
const ForgotPass = lazy(() => import("containers/ForgotPass"));
const ResendConfirmation = lazy(() => import("containers/ResendConfirmation"));
 const AdminUpdateMedia = lazy(()=> import ("containers/AdminUpdateMedia"));
 const AdminMediaViewEditRelease = lazy(()=>import ('containers/AdminMediaViewEditRelease'));
 const AdminCreateMedia = lazy(()=>import ('containers/AdminCreateMedia'));
 const AdminMediaEdit  = lazy(()=>import ('containers/AdminMediaEdit'));
 const InstructionHowTo  = lazy(()=>import('./containers/InstructionHowTo'))
 const AboutDownloads = lazy(()=>import('./containers/AboutDownloads'))


const LoadingMessage = () => (
  <Pane
    alignItems="center"
    justifyContent="center"
    width="100%"
    display="flex"
    height="100vh"
  >
    <Spinner />
  </Pane>
);

export default () => (
  <BrowserRouter>
    <Fragment>
      <Header />
      <Suspense fallback={<LoadingMessage />}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path='/instructionHowTo' exact component={InstructionHowTo}/>
          <Route path='/downloads' exact component={AboutDownloads}/>
          <Route path="/become-involved" exact component={BecomeInvolved} />
          <Route path="/funding" exact component={Funding} />
          <Route path="/media" exact component={Media} />
          <Route path="/media/:id" component={MediaDetail} />
          <Route path="/privacy" component={Privacy} />
          <Route path="/contact" exact component={Contact} />
          <AuthenticatedRoute path="/log" exact component={Log} />
          <AuthenticatedRoute path="/map" exact component={Map} />
          <AuthenticatedRoute path="/graph" exact component={Graph} />
          <AuthenticatedRoute
            path="/case-reports"
            exact
            component={CaseReports}
          />
          <AuthenticatedRoute
            path="/case-reports/:id"
            exact
            component={CaseReportDetail}
          />
          <AuthenticatedRoute
            path="/case-reports/:id/edit"
            exact
            component={CaseReportEdit}
          />
          <Route path="/vaccination" exact component={Vaccination} />
          <AuthenticatedRoute path="/account" exact component={Account} />
          <UnauthenticatedRoute path="/signup" exact component={Signup} />
          <UnauthenticatedRoute
            path="/signup/verify"
            exact
            component={AccountVerification}
          />
          <UnauthenticatedRoute
            path="/forgot-password"
            exact
            component={ForgotPass}
          />
          <UnauthenticatedRoute
            path="/password-reset"
            exact
            component={PasswordReset}
          />
          <UnauthenticatedRoute
            path="/resend-confirmation"
            exact
            component={ResendConfirmation}
          />
          <AdminRoute path="/admin/cases" exact component={AdminCases} />
          <AdminRoute path="/admin/update-media" exact component={AdminUpdateMedia} />
          <AdminRoute path="/admin/media-release" exact component={AdminMediaViewEditRelease} />
          <AdminRoute path="/admin/media-release/:id" exact component={AdminMediaEdit} />
          <AdminRoute path="/admin/create-media-release" exact component={AdminCreateMedia} />


          <AdminRoute
            path="/admin/cases/:cognitoId/:id"
            exact
            component={AdminCasesDetail}
          />
          <AdminRoute
            path="/admin/cases/:cognitoId/:id/edit"
            exact
            component={AdminCaseEdit}
          />
          <AdminRoute
            path="/admin/groups"
            exact
            component={AdminPendingGroups}
          />
          <AdminRoute path="/admin/users" exact component={AdminUsers} />
          <AdminRoute
            path="/admin/users/:cognitoId"
            exact
            component={AdminUsersDetail}
          />
          <AdminRoute
            path="/admin/users/:cognitoId/edit"
            exact
            component={AdminUsersEdit}
          />
          <AdminRoute
            path="/admin/organisations"
            exact
            component={AdminOrganisations}
          />
          <AdminRoute
            path="/admin/organisations/:organisationNumber/edit"
            exact
            component={AdminOrganisationsEdit}
          />
          <AdminRoute
            path="/admin/pending-organisations"
            exact
            component={AdminPendingOrganisations}
          />
          <AdminRoute
            path="/admin/merge-organisations/"
            exact
            component={AdminMergeOrganisations}
          />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
      <Footer />
    </Fragment>
  </BrowserRouter>
);
